require("./bootstrap");
require("./sms-counter.min");
require("./timesheet");

import Alpine from "alpinejs";
import ApexCharts from 'apexcharts';
import columnChart from "./charts/columnChart";

import { arrayMoveMutable } from 'array-move';

window.Alpine = Alpine;
window.ApexCharts = ApexCharts;
window.livewireChartsColumnChart = columnChart;

Alpine.start();

function visit(url) {
    window.location.assign(url);
}

function download(url) {
    window.open(url, "_blank");
}

window.visit = visit;
window.download = download;
window.arrayMove = arrayMoveMutable;
